import React from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import InfoCircle from '../icons/info-circle';
import colors from '../../theme/colors';

const Info = styled.span<{ top: string }>`
  position: relative;
  left: 5px;
  top: ${props => props.top}px;
`;

const useStyles = makeStyles({
  root: {
    backgroundColor: colors.darkBackgroundBase,
    color: colors.labelPlatinum,
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
  },
});

export interface IToolTip {
  title: string;
  top?: string;
  placement?: TooltipProps['placement'];
}

export default ({ title, placement = 'right', top = '5px' }: IToolTip) => {
  const { root } = useStyles();
  return (
    <Tooltip placement={placement} title={<span>{title}</span>} classes={{ tooltip: root }}>
      <Info top={top}>
        <InfoCircle width={20} height={20} />
      </Info>
    </Tooltip>
  );
};
